export default __webpack_public_path__ + "static/media/NAWIGATOR.7de2b119.png";